<template>
  <div class="wgtSettings" :class="{ 'isTableShown': isShowTable }">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="bubblesnap">
          <div class="content-panel1" v-show="IsbubbleErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">Distribution Chart</h2>
            <apiErrorComponent @tryReload="tryReload" compTitle="Distribution Chart" compId="bubblesnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1" v-show="!IsbubbleErr">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IsbubbleErr">
                  <font-awesome-icon :icon="['fas', 'eye']" title="Show Blank Values" v-on:click="removeBlank()"
                    v-show="isRemoveBlank" />
                  <font-awesome-icon :icon="['fas', 'eye-slash']" title="Hide Blank Values" v-on:click="removeBlank()"
                    v-show="!isRemoveBlank" />
                  <font-awesome-icon icon="fa-solid fa-table" v-on:click="showTable()"
                    :title="isShowTable ? 'Hide Table' : 'Show Table'" />
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                    v-on:click="addToSlider()" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.bubbleinfo }} You can drag the mouse over area where you want to zoom.
                You can also click on individual scatters to get more insights.
                <br />
                <br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" :icon="['fas', 'eye']" /> to see non blank
                    values and
                    <font-awesome-icon class="actIcon" :icon="['fas', 'eye-slash']" /> to see blank
                    values
                  </li>

                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-table" />
                    to see table with values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" />
                    to add to storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" />
                    to download the chart with current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-export" />
                    to download all the insights
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isBubbleLoaded">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="isBubbleLoaded" chart-loader-spin></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">Distribution Chart</h2>
            <div class="panel-body text-center">
              <div class="fltrSelc_mrg">
                <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="bubbleFilter"
                  :options="bubbleFilteron" :multiple="false" :allow-empty="false" selectLabel=""
                  deselect-label="can't Deselect" :close-on-select="true" @select="getBubbleChart"
                  :placeholder="bubbleFilter.name" track-by="name" label="name" />
              </div>
              <div class="chartHeightControlBC">
                <div id="bubbleChart"></div>
              </div>
              <div v-if="isShowTable">
                <ag-grid-vue style="width: 96%;height:470px;"
                  class="table-striped thmHead myMttrTbl v01 ag-theme-alpine myHomeTable" :columnDefs="asgcolsDefs"
                  @grid-ready="onPriorAsg">
                </ag-grid-vue>
              </div>
              <div v-if="Isbubbledata" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
              <div v-if="IsbubbleErr">
                <widgetErrorImg></widgetErrorImg>
              </div>
            </div>
            <widgetsSlider :insideArr="bubbleinsight" :isInsErr="IsbtInsErr" compTitle="Distribution Chart"
              compId="bubblesnap" :isErr="IsbubbleErr"></widgetsSlider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var scatterChartData, chartDomBubble, myChartBubble, chkFilterOn, valR, wholeScatter = [];
function reportWindowSizeBubble() {
  if (myChartBubble != undefined) {
    myChartBubble.resize();
  }
}
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import domtoimage from "dom-to-image-more";
import {
  saveAs
} from 'file-saver';
import {
  AgGridVue
} from "@ag-grid-community/vue3";
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetErrorImg from '../smallcomp/chartErrImg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue';
import widgetsSlider from '../smallcomp/widgets-slider.vue';
function convert2ddhhmm(minutesValue, suffix) {
  if (suffix != "") {
    if (suffix.toUpperCase() == "H") {
      minutesValue = minutesValue * 60;
    } else if (suffix.toUpperCase() == "D") {
      minutesValue = minutesValue * 60 * 8;
    }
    var hours = Math.floor(minutesValue / 60);
    var minutes = Math.round((minutesValue % 60), 2);
    var days = 0;
    if (hours > 24) {
      days = Math.floor(hours / 24);
      hours = Math.floor(hours % 24);
    }
    var returnVal = '';
    if (days != 0) {
      returnVal += days + 'd ';
    }
    if (hours != 0) {
      returnVal += hours + 'h ';
    }
    if (minutes != 0) {
      returnVal += minutes + 'm ';
    }
  } else {
    returnVal = minutesValue;
  }
  if (returnVal == 0) {
    returnVal = '-'
  }
  return returnVal;
}
export default {
  name: 'BubbleTrend',
  mixins: [screenShotMix],
  components: {
    widgetDataMsg,
    widgetErrorImg,
    widgetLoadingComp,
    AgGridVue,
    apiErrorComponent,
    widgetsSlider
  },
  props: {
    getpass: Object,
    getPins: Object,
    tabname: String,
  },
  data() {
    return {
      isBubbleLoaded: false,
      IsbubbleErr: false,
      Isbubbleshow: true,
      Isbubbledata: false,
      IsbtInsErr: false,
      isShowTable: false,
      isRemoveBlank: false,
      isBCshow: true,
      bubbleFilteron: this.getpass.bubbleFilteron,
      bubbleFilter: "",
      bubbleinsight: [],
      myColorArray: [],
      resetValue: {},
      asgcolsDefs: [],
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
      isChartRedraw: true,
    }
  },
  methods: {
    pagNav(index) {
      this.paginNo = index;
      this.paginIdx = "transform: translateX(-" + 5 * index + "%)"
    },
    tryReload() {
      if (this.bubbleFilteron != undefined) {
        chkFilterOn = this.bubbleFilteron.find(element => element.ticked == true)
        this.bubbleFilter = chkFilterOn
      }
      this.getBubbleChart(chkFilterOn, this.getwgtCond)
    },
    addToSlider() {
      let insArr = this.bubbleinsight;
      let name = "Distribution Chart - " + this.getPins.viewName;
      let screenShort = {
        id: 'bubblesnap',
        name: 'bubblesnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    showTable() {
      if (this.isShowTable) {
        this.isShowTable = false
      } else {
        this.isShowTable = true;
      }
    },
    daysGetter(params) {
      var pier = params.data["Time Taken"]
      pier = Math.round(pier * 60);
      var hours = Math.floor(pier / 60);
      var minutes = pier % 60;
      var timeret = "";
      if (hours > 0) {
        if (hours < 24) {
          timeret += hours + "h ";
        } else {
          var days = Math.floor(hours / 24);
          hours = hours - (days * 24);
          timeret += days + "d " + hours + "h ";
        }
      }
      if (minutes > 0) {
        timeret += minutes + "m ";
      }
      if (timeret == "") {
        timeret = "< 1min"
      }
      return timeret
    },
    onPriorAsg(params) {
      this.asgLisApi = params.api
      this.gridColumnApi = params.columnApi
      this.asgLisApi.setRowData(this.datasetT);
      params.api.sizeColumnsToFit();
    },
    resetChart() {
      let chkFilterTrue = this.bubbleFilteron.find(element => element.ticked == true)
      this.bubbleFilter = chkFilterTrue
      this.getBubbleChart(this.resetValue.chkFilterOn, this.resetValue.getwgtCond)
    },
    downloadDom() {
      let imgname = "Distribution_Chart.png"
      let widgetID = "bubblesnap"
      var geticondiv = document.querySelectorAll('#bubblesnap .insideL,#bubblesnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downIns() {
      let fileName = 'DistributionChart_Insights.txt'
      let insArr
      insArr = this.bubbleinsight.join("\r\n")
      var fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    swapCharts() {
      this.isBCshow = !this.isBCshow;
      if (this.isBCshow) {
        this.drawBubbleChart();
      } else {
        this.drawBarChart();
      }
    },
    drawBubbleChart() {
      let emit = this.$emit
      chartDomBubble = document.getElementById('bubbleChart');
      if(chartDomBubble == null) return;
      if (chartDomBubble != null && chartDomBubble != undefined) {
        chartDomBubble.style.height = "345px";
        let xArr = [],
          yArr = []
        for (let index = 0; index < scatterChartData.datasets.length; index++) {
          const element = scatterChartData.datasets[index];
          xArr.push(element.data[0].x)
          yArr.push(element.data[0].y)
        }
        let xSum = xArr.reduce((a, b) => a + b, 0) / xArr.length,
          ySum = yArr.reduce((a, b) => a + b, 0) / yArr.length,
          xVal, yVal;
        let seriesArr = [];
        for (let index = 0; index < scatterChartData.datasets.length; index++) {
          const element = scatterChartData.datasets[index];
          xVal = element.data[0].x > (xSum) ? 4 : element.data[0].x > (xSum / 2) ? 2 : 0
          yVal = element.data[0].y > (ySum) ? 4 : element.data[0].y > (ySum / 2) ? 2 : 0
          if (this.isRemoveBlank) {
            if (element.data[0].value != "(Blanks)") {
              seriesArr.push({
                type: 'scatter',
                id: element.data[0].value,
                dataGroupId: element.data[0].value,
                animationEasing: 'bounceOut',
                data: [
                  [element.data[0].x, element.data[0].y, xVal + yVal]
                ],
                symbolSize: 10,
                name: element.data[0].value,
              })
            }
          } else {
            seriesArr.push({
              type: 'scatter',
              id: element.data[0].value,
              dataGroupId: element.data[0].value,
              animationEasing: 'bounceOut',
              data: [
                [element.data[0].x, element.data[0].y, xVal + yVal]
              ],
              symbolSize: 10,
              name: element.data[0].value,
            })
          }
        }
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myChartBubble = echarts.init(chartDomBubble);
        }
        valR = this.bubbleFilter.dbname;
        let optionBubble = {
          grid: {
            top: 20,
            left: 110,
            right: 20,
            bottom: 20,
          },
          tooltip: {
            formatter: (params) => {
              return params.seriesName + " has " + parseInt(params.value[0]).toLocaleString() + " tickets taking " +
                convert2ddhhmm(params.value[1], 'H') + " avg time.";
            },
            confine: true
          },
          toolbox: {
            right: 20,
            itemSize: 20,
            iconStyle: {
              borderColor: '#777'
            },
            feature: {
              dataZoom: {},
            }
          },
          visualMap: {
            type: 'continuous',
            top: 0,
            calculable: true,
            text: ['High', 'Low'],
            min: 0,
            max: 8,
            inRange: {
              color: this.$store.state.chartColor
            },
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          xAxis: {
            scale: true,
            type: 'value',
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              color: "#777"
            },
          },
          yAxis: {
            scale: true,
            type: 'value',
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              fontSize: 10,
              color: "#777",
              formatter: function (value, index) {
                return convert2ddhhmm(value, "H");
              }
            },
          },
          series: seriesArr,
        };
        myChartBubble.setOption(optionBubble, {
          notMerge: true
        });
        myChartBubble.on('click', function (params) {
          if (params.componentType === 'series') {
            let clickitem = {
              "currpass": params.seriesName,
              "filterop": valR
            }
            emit("getKDrill", clickitem)
          }
        });
      }
    },
    getBubbleChart(getfilter, BubbleCond) {
      BubbleCond = this.getwgtCond
      this.isBubbleLoaded = false
      this.IsbubbleErr = false
      this.Isbubbleshow = false
      this.Isbubbledata = false
      this.IsbtInsErr = false
      if (getfilter != "") {
        getfilter = getfilter.dbname
      }
      this.axios.post(this.uriApiUrl + 'DataAnalysis/get_bubble_chart?asg_id=' + this.asgId + "&Cond=" +
        BubbleCond, {
        "colval": getfilter,
        "get_prior": this.getPins.get_prior,
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              scatterChartData = response.data
              this.bubbleinsight = scatterChartData.insights
              wholeScatter = Object.assign([], scatterChartData.datasets)
              this.datasetT = scatterChartData.tableView;
              this.asgcolsDefs = [{
                headerName: this.bubbleFilter.name,
                field: 'Value',
                sortable: true,
              },
              {
                headerName: '# Tickets',
                field: 'Count',
                sortable: true,
              },
              {
                headerName: 'Time Taken',
                field: 'Time Taken',
                sortable: true,
                valueGetter: this.daysGetter,
              }
              ]
              if (this.bubbleinsight.length == 0) {
                this.IsbtInsErr = true
              }
              this.Isbubbleshow = true
              if (this.isChartRedraw) {
                try {
                  echarts.dispose(myChartBubble);
                } catch (error) {
                  // console.log("..")
                }
              }
              setTimeout(() => {
                this.drawBubbleChart()
              }, 100);
            } else if (response.data == "Nodata") {
              this.Isbubbledata = false
              this.bubbleinsight = []
            } else {
              this.IsbubbleErr = true
              this.bubbleinsight = []
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in BubbleTrend. Try after sometime!'
              })
            }
          }
          this.isBubbleLoaded = true
        }).catch((response) => {
          this.IsbubbleErr = true
          this.isBubbleLoaded = true
          this.isAnalysisload = false
          this.bubbleinsight = []
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in BubbleTrend. Try after sometime!'
            })
          }
        })
    },
    removeBlank(condition) {
      this.isRemoveBlank = !this.isRemoveBlank;
      if (this.isBCshow) {
        this.drawBubbleChart();
      } else {
        this.drawBubbleChart();
      }
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.myColorArray = [this.getgradOrange]
    if (this.bubbleFilteron != undefined) {
      chkFilterOn = this.bubbleFilteron.find(element => element.ticked == true)
      this.bubbleFilter = chkFilterOn
    }
    this.resetValue.chkFilterOn = chkFilterOn
    this.resetValue.getwgtCond = this.getwgtCond
    this.getBubbleChart(chkFilterOn, this.getwgtCond)
    this.isChartRedraw = true
    window.addEventListener("resize", reportWindowSizeBubble);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeBubble);
  },
  computed: {
    getwgtCond() {
      return this.$store.state.widgetCond
    },
  },
  watch: {
    getPins() {
      this.getBubbleChart(this.bubbleFilter, this.getwgtCond)
    },
    getpass() {
      this.getBubbleChart(chkFilterOn, this.getwgtCond)
    },
    '$store.state.chartColor': function () {
      if (myChartBubble != undefined) {
        this.getBubbleChart(chkFilterOn, this.getwgtCond)
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fltrSelc_mrg {
  margin-top: -10px
}</style>